import React, {useState} from "react";
import {AnimatePresence} from "framer-motion";
import AccessGate from "./components/AccessGate";
import CrosswordBoard from "./components/Crossword/CrosswordBoard";
import Postcard from "./components/Postcard/Postcard";
import styles from "./Parigi.module.css";

const Parigi = () => {
    const [stage, setStage] = useState('gate'); // gate -> crossword -> postcard

    return (
        <div className={styles.page}>
            <AnimatePresence mode="wait" initial={false}>
                {stage === 'gate' && (
                    <AccessGate key="gate" onUnlock={() => setStage('crossword')}/>
                )}
                {stage === 'crossword' && (
                    <CrosswordBoard key="crossword" onOpenPostcard={() => setStage('postcard')}/>
                )}
                {stage === 'postcard' && (
                    <Postcard key="postcard"/>
                )}
            </AnimatePresence>
        </div>
    );
};

export default Parigi;
